import React from 'react';

const NotFound = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="card">
        <h1 className="text-3xl font-bold mb-4">404 - Page Not Found</h1>
        <p className="text-gray-600">This page is under construction.</p>
      </div>
    </div>
  );
};

export default NotFound;
